import { RootState } from '~/redux-toolkit/store/store';
import { useSelector } from 'react-redux';
import { ROUTES } from '~/data/routes';

const useSelectFilters = (type: string) => {
  const { query } = useSelector((state: RootState) => state.resultPage);
  const { usedCarQuery } = useSelector(
    (state: RootState) => state.usedCarFilters,
  );

  if (type === ROUTES.USED_CAR) {
    return usedCarQuery.filters;
  }

  return query.filters;
};

export default useSelectFilters;
